import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    Svg,
    Path
} from '@react-pdf/renderer';

export interface ListaEtiquetas {
    aF_UBICACION?: string;
    aF_CODIGO_GENERICO?: string;
    aF_DESCRIPCION?: string;
    origen?: string;
    eS_TRASPASO?: number;
    estabL_CORR_DESTINO?: number;
    qrSvg?: {
        viewBox: string;
        paths: { d: string; fill?: string; stroke?: string }[];
    };
}

const styles = StyleSheet.create({
    page: {
        padding: 0,
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    fullPageContainer: {
        width: '100%',
        padding: 5,
        flexDirection: 'row',
        alignItems: 'center',
    },

    qrImage: {
        width: 100,
        height: 100,
        marginRight: 6,
    },

    infoContainer: {
        flex: 1,
        height: 100,
        position: 'relative',
        justifyContent: 'flex-start',
    },

    ubicacion: {
        fontSize: 12,
        marginBottom: 10,
    },

    codigo: {
        fontSize: 12,
        marginBottom: 10,
    },

    descripcion: {
        fontSize: 12,
        lineHeight: 1.1,
    },
    establecimiento: {
        fontSize: 11,
        lineHeight: 1.1,
    },
    traspaso: {
        position: 'absolute',
        bottom: 0,
        right: 0,
        fontSize: 11
    }
});

const DocumentoEtiquetasPDF = ({ row = [] }: { row: ListaEtiquetas[] }) => (
    <Document>
        {row.length > 0 ? (
            row.map((lista, index) => (
                <Page
                    key={index}
                    size={{ width: 300, height: 110 }}
                    style={styles.page}
                >
                    <View style={styles.fullPageContainer}>

                        {lista?.qrSvg ? (
                            <Svg
                                style={styles.qrImage}
                                viewBox={lista.qrSvg.viewBox}
                            >
                                {lista.qrSvg.paths.map((p, idx) => (
                                    <Path
                                        key={idx}
                                        d={p.d}
                                        fill={p.fill ?? "none"}
                                        stroke={p.stroke ?? "none"}
                                    />
                                ))}
                            </Svg>
                        ) : (
                            <Text>Sin QR</Text>
                        )}

                        <View style={styles.infoContainer}>

                            <Text style={styles.ubicacion}>
                                {lista?.aF_UBICACION ?? ""}
                            </Text>

                            <Text style={styles.codigo}>
                                {lista?.aF_CODIGO_GENERICO ?? ""}
                            </Text>

                            <Text style={styles.descripcion}>
                                {lista?.aF_DESCRIPCION ?? ""}
                                {"\n"}
                                {lista?.origen
                                    ? lista.origen.charAt(0).toUpperCase() +
                                    lista.origen.slice(1).toLowerCase()
                                    : ""}
                            </Text>

                            <Text style={styles.establecimiento}>
                                {lista?.estabL_CORR_DESTINO == 1 ? "SSMSO" :
                                    lista?.estabL_CORR_DESTINO == 2 ? "CASR" :
                                        lista?.estabL_CORR_DESTINO == 3 ? "HSJM" : ""}
                                {"\n"}
                            </Text>


                            {lista.estabL_CORR_DESTINO !== 0 && (
                                <Text style={styles.traspaso}>
                                    Traspaso
                                </Text>
                            )}

                        </View>

                    </View>
                </Page>
            ))
        ) : (
            <Page size={{ width: 300, height: 110 }} style={styles.page}>
                <Text>No hay etiquetas para mostrar</Text>
            </Page>
        )}
    </Document>
);

export default DocumentoEtiquetasPDF;